/**
 * <ClosableHeader> — la barre de titre d'un écran qu'on referme (molecule).
 *
 * La croix à gauche, le titre, et à droite la flèche de relecture quand l'écran en a une : la tête
 * des écrans que l'élève ouvre depuis « Mon compte » (ses quêtes, le classement, la boutique), et de
 * « Mon compte » et de ses contrôles.
 * Écrite une fois, pour qu'ils gardent la même croix et le même nom accessible.
 *
 * Un habillage de `<Header>` : ses fentes sont prises, le reste de ses props passe tel quel.
 *
 * Composes DS pieces only — `<Header>`, `<IconButton>`, `<RefreshButton>`.
 */
import React from "react"

import { IconButton } from "../../atoms/Buttons/IconButton"
import { Header, type HeaderProps } from "../Header"
import { RefreshButton } from "../RefreshButton"

export type ClosableHeaderProps = Omit<HeaderProps, "left" | "right" | "steps"> & {
    /** La croix. Absente : pas de croix. */
    onClose?: () => void
    /** La relecture. Absente : pas de flèche. */
    onRefresh?: () => void
    /** Une relecture est en cours : la flèche tourne. Défaut `false`. */
    refreshing?: boolean
}

const TEXTS = { close: "Fermer" }

export function ClosableHeader(props: ClosableHeaderProps) {
    const { onClose, onRefresh, refreshing = false, ...header } = props

    return (
        <Header
            {...header}
            left={
                onClose != null ? (
                    <IconButton
                        iconName="times"
                        appearance="transparent"
                        iconColor="primary"
                        onPress={onClose}
                        accessibilityLabel={TEXTS.close}
                    />
                ) : undefined
            }
            right={onRefresh != null ? <RefreshButton refreshing={refreshing} onRefresh={onRefresh} /> : undefined}
        />
    )
}
